<template>
    <voffice-popup-box :trigger-id="triggerId"
        class="full-xxs datepickerpopup"
        id="datepicker"
        :apply-label="applyLabel"
        :close-btn-disabled="closeBtnDisabled"
        @closed="onClosed">

        <div class="datepicker-trigger">

            <airbnb-style-datepicker :trigger-element-id="triggerId"
                :close-after-select="false"
                :inline="true"
                :show-shortcuts-menu-trigger="false"
                :show-action-buttons="false"
                :offset-y="10"
                :mode="'range'"
                :show-month-year-select="true"
                :fullscreen-mobile="false"
                :disabled-dates="disabledDays"
                :customized-dates="calClasses"
                :min-date="minDate"
                :end-date="maxDate"
                :date-one="from"
                :date-two="till"
                @closed="onClosed"
                :mobile-header="mobileHeader"
                @date-one-selected="onFromSelected"
                @date-two-selected="onTillSelected" />

            <div>
                <div class="pickerhint">
                    <div v-if="!from">
                        Bitte wählen Sie Ihren Anreisetag aus.
                    </div>

                    <div v-if="from && ! till">
                        Bitte wählen Sie jetzt Ihren Abreisetag aus.
                    </div>

                    <div v-if="from && till">
                        Wählen Sie aus, wie viele Nächte Sie bleiben möchten.
                    </div>
                </div>
                <div class="datepicker-ext-row"
                    v-if="possibleNights">
                    <span>{{voMsg('min.label')}}</span>
                    <select v-model="minNights">
                        <option v-for="option in possibleNights"
                            v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    <span>{{voMsg('max.label')}}</span>
                    <select v-model="maxNights">
                        <option v-for="option in possibleNights"
                            v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>

                </div>
            </div>

        </div>
    </voffice-popup-box>

</template>
<script>
    import {
    	isBlank
    }
    from 'voUtils/tools.js';
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'voffice-daterange-ext',
    	voMsgCodes: [
    		'weekdayslist.short',
    		'monthlist.full',
    		'weekdayslist',
    		'night.pl',
    		'min.label',
    		'max.label',
    	],

    	data() {
    		return {
    			needTill: false,
    			nextArrivalDate: undefined,
    			disabledArrivalDays: [],
    			disabledDepartureDays: [],
    			minNights: undefined,
    			maxNights: undefined,
    			diffDays: undefined,
    			calClasses: [],
    			cal: undefined,
    		};
    	},

    	props: {
    		from: String,
    		till: String,
    		nights_min: Number,
    		nights_max: Number,
    		triggerId: String,
    		fullscreenMobile: Boolean,
    		applyLabel: String,
    	},

    	computed: {
    		disabledDays: function() {
    			return this.needTill ? this.disabledDepartureDays : this.disabledArrivalDays;
    		},
    		closeBtnDisabled: function() {
    			return !this.from || !this.till;
    		},
    		possibleNights: function() {
    			if (this.from && this.till) {
    				const diff = DateEx.getDays(this.till, this.from);
    				this.diffDays = diff;
    				let result = [];
    				for (let i = 1; i <= diff; i++) {
    					result.push({
    						value: i,
    						text: i + ' ' + this.voMsgPl('night.pl', i),
    					});
    				}
    				return result;
    			}
    			return undefined;
    		},
    		mobileHeader: function() {
    			return this.needTill ? this.voMsg("daterange.till") : this.voMsg("daterange.from");
    		},
    		minDate: function() {
    			return this.needTill ? DateEx.plusDays(this.from, 1) : DateEx.interfaceFormat(DateEx.getToday());
    		},
    		maxDate: function() {
    			return this.needTill ? this.nextArrivalDate : this.addDays(730);
    		}
    	},

    	methods: {

    		addDays: function(days) {
    			const today = new Date();
    			today.setDate(today.getDate() + days);

    			const year = today.getFullYear();
    			const month = String(today.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
    			const day = String(today.getDate()).padStart(2, '0');

    			return year + '-' + month + '-' + day;
    		},
    		onClosed: function() {
    			if (this.$parent.searchData.from && !this.$parent.searchData.till) {
    				this.$parent.searchData.till = DateEx.interfaceFormat(DateEx.plusDays(this.$parent.searchData.from, 7));
    			}

    			setTimeout(() => {
    				this.$emit('closed');
    			}, 50);
    		},

    		onFromSelected(d) {
    			this.needTill = true;
    			this.$emit('update:from', d);
    			this.$emit('update:till', undefined);
    		},

    		onTillSelected: function(d) {
    			this.needTill = isBlank(d) && this.from;
    			this.$emit('update:till', d);

    			setTimeout(() => {
    				this.$emit('on-tilldate-selected');
    			}, 50);
    		},

    		resetNightsToDiff: function() {
    			if (this.from && this.till) {
    				const diff = DateEx.getDays(this.till, this.from);
    				this.minNights = diff;
    				this.maxNights = diff;
    			}
    		}
    	},

    	watch: {
    		/*from: function() {
    			console.log('Watch From');
    			this.resetNightsToDiff();
    		},*/
    		till: function() {
    			var diff1 = 1;
    			var diff2 = 2;
    			if (this.diffDays) {
    				diff1 = this.diffDays;
    				var diff2 = DateEx.getDays(this.till, this.from);
    			}
    			//console.log('DiffDays1::', diff1);
    			//console.log('DiffDays2::', diff2);
    			if (diff1 != diff2) {
    				this.resetNightsToDiff();
    			} else {
    				this.minNights = this.nights_min;
    				this.maxNights = this.nights_max;
    			}
    		},
    		minNights(newVal) {
    			this.$emit('update:nights_min', newVal);
    			if (this.maxNights && this.maxNights < newVal) {
    				this.maxNights = newVal;
    			}
    		},
    		maxNights(newVal) {
    			this.$emit('update:nights_max', newVal);
    			if (this.minNights && this.minNights > newVal) {
    				this.minNights = newVal;
    			}
    		}
    	}
    };
</script>